import http from './http';

export async function pageTasks(params) {
  const { data } = await http.get('/api/user/tasks/page', { params });
  return data;
}

export async function taskRead(id) {
  const { data } = await http.post(`/api/user/tasks/${id}/read`);
  return data;
}

export async function taskConfirm(id) {
  const { data } = await http.post(`/api/user/tasks/${id}/confirm`);
  return data;
}

export async function taskReceipt(id, payload) {
  const { data } = await http.post(`/api/user/tasks/${id}/receipt`, payload);
  return data;
}

export async function getTaskRedDot() {
  const { data } = await http.get('/api/user/tasks/red-dot');
  return data;
}

